import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { LogoCarousel } from '../components/landing/LogoCarousel';
import { Work } from '../components/landing/Work';
import { Services } from '../components/landing/Services';
import { About } from '../components/landing/About';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full overflow-x-hidden" style={{
    background: 'var(--bg)',
    color: 'var(--fg)'
  }} data-id="element-273" data-mp="2az9c5wduvemr">
      <Navbar data-id="element-274" data-mp="2kygpijklb99v" />
      <Hero data-id="element-275" data-mp="2kz0904pw25q0" />
      <LogoCarousel data-id="element-276" data-mp="2kxp6s9c3d610" />
      <Work data-id="element-277" data-mp="2kxyxy08vhj8a" />
      <Services data-id="element-278" data-mp="2kwnslvzs43f2" />
      <About data-id="element-279" data-mp="2fznmjl2xj0ny" />
      <Footer data-id="element-280" data-mp="2fz4505h6yeag" />
    </div>;
}